import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useMemo } from "react";
import { CATEGORY } from "src/constants/searchParams";
import { useSearchParams } from "react-router-dom";
import Filter from "src/components/TableFilter";
import { useManageModal } from "src/hooks/useManageModal";
import { useGetExperimentsQuery } from "src/api/services/experimentsApi";
import { filters } from "./utils/filters";
import { usePagination } from "src/hooks/usePagination";
import { useFromAndTo } from "src/hooks/useFromAndTo";
import DataTable from "src/components/DataTable";
import { useColumns } from "./utils/columns";
import CreateNewExperimentModal from "src/components/Modals/CreateNewExperimentModal";
import { useDrawerContext } from "src/context/drawers/ExperimentsDrawerProvider";

const Experiments = () => {
  const pagination = usePagination();
  const { from, to } = useFromAndTo();
  const { handleOpenUpdateItem } = useDrawerContext();

  const height = useMemo(
    () => window.innerHeight - 42 - 60 - 32 - 52 - 32 - 4,
    [],
  );
  const [params] = useSearchParams();
  const [open, { handleClose, handleOpen }] = useManageModal();

  const queryParams = useMemo(() => {
    return {
      category: params.get(CATEGORY) ?? undefined,
      from,
      to,
    };
  }, [from, params, to]);

  const { data, isFetching } = useGetExperimentsQuery(queryParams);

  const { experiments, count } = useMemo(() => {
    if (data == null) {
      return { experiments: [], count: 0 };
    }

    return { experiments: data.data, count: data.count };
  }, [data]);

  const columns = useColumns(handleOpenUpdateItem);

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4" fontWeight={600}>
          Experiments
        </Typography>
        <Button startIcon={<AddIcon />} onClick={handleOpen}>
          Add New
        </Button>
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        height={60}
        alignItems="center"
      >
        <Stack
          direction="row"
          gap="16px"
          flexWrap="wrap"
          width="100%"
          alignItems="center"
        >
          {filters.map((filter) => (
            <Filter key={filter.name} current={filter} />
          ))}
        </Stack>
      </Stack>
      <Stack gap={0}>
        <Box height={4}>
          {isFetching ? <LinearProgress color="success" /> : null}
        </Box>
        <DataTable
          columns={columns}
          data={experiments}
          total={count}
          primaryKey="id"
          height={height}
          pagination={pagination}
        />
      </Stack>
      <CreateNewExperimentModal onClose={handleClose} open={open} />
    </Stack>
  );
};

export default Experiments;
